<template>
    <div class="emr-lookup-practice-modal">

        <!-- emr lookup modal activation button -->
        <b-btn class="btn-secondary ml-2"
               size="sm"
               @click="emrLookupShow($event)">
            {{ $i18n.gt('LABEL_LOOKUP') }}
        </b-btn>

        <!-- modal -->
        <b-modal hide-footer
                 size="xl"
                 :id="modal_id"
                 :title="$i18n.gt('LABEL_EMR_LOOKUP')">

            <data-table ref="dataTable"
                        :show-filters="true"
                        :show-pager="true"
                        :show-details="false"
                        :get-items="getPractices"
                        :filters="filters"
                        :fields="fields">

                <!-- custom template for filters -->
                <template v-slot:filters>
                    <b-row cols="3">
                        <b-col>
                            <b-form-group horizontal
                                          :label="$i18n.gt('LABEL_NAME')">
                                <b-form-input v-model="filters.name.value"
                                              @input="filtersChanged()"/>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group horizontal
                                          :label="$i18n.gt('LABEL_CITY')">
                                <b-form-input v-model="filters.city.value"
                                              @input="filtersChanged()"/>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group horizontal
                                          :label="$i18n.gt('LABEL_STATE')">
                                <b-form-input v-model="filters.state.value"
                                              @input="filtersChanged()"/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>

                <!-- template for custom columns -->
                <template v-slot:customField="slotProps">
                    <div v-if="slotProps.row.field.key === 'actions'">
                        <b-btn class="btn btn-ghost-blue btn-sm btn-icon mr-2"
                               @click="selectRecord(slotProps.row.item, false)">
                            {{ $i18n.gt('LABEL_EMR_COPY_IDENTIFIER') }}
                        </b-btn>
                        <b-btn class="btn btn-ghost-blue btn-sm btn-icon mr-2"
                               @click="selectRecord(slotProps.row.item, true)">
                            {{ $i18n.gt('LABEL_EMR_COPY_ALL') }}
                        </b-btn>
                        <b-btn v-if="canDelete"
                               class="btn btn-sm btn-icon mr-2"
                               variant="danger"
                               @click="deleteRecord(slotProps.row.item)">
                            {{ $i18n.gt('LABEL_EMR_DELETE') }}
                        </b-btn>
                    </div>
                </template>
            </data-table>
        </b-modal>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'emr-lookup-practice-modal',
    props: {
        fieldModel: {type: Object, default: null},
        form: {type: Object, default: null},
        company: {type: Number, default: null},
    },
    data() {
        return {
            modal_id: "emrLookupPractitioner",
            filters: {
                name: {field: 'name', value: null},
                city: {field: 'city', value: null},
                state: {field: 'state', value: null},
            },
            canDelete: false,
        }
    },
    computed: {
        fields() {
            return [
                {key: 'name', sortable: true, label: this.$i18n.gt('LABEL_NAME')},
                {key: 'city', sortable: true, label: this.$i18n.gt('LABEL_CITY')},
                {key: 'state', sortable: false, label: this.$i18n.gt('LABEL_STATE')},
                {key: 'actions', sortable: false, custom: true, label: ''},
            ]
        }
    },
    methods: {
        emrLookupShow(e) {
            if (e.shiftKey && this.$user.roleIs('ADMIN')) {
                this.canDelete = true
            }
            if (this.fieldModel && this.fieldModel.fields && this.form) {
                if (this.form['name'] && this.form['name'].$model) {
                    this.filters.name.value = this.form['name'].$model
                }
            }
            this.$bvModal.show('emrLookupPractitioner')
        },
        getPractices(listParams) {
            let filters = this.filters
            filters['type'] = {field: 'type', value: 'practice'}
            return this.$api.emrLookup(this, this.filters, listParams, {company: this.company})
        },
        filtersChanged() {
            this.$refs.dataTable.debouncedRefresh()
        },
        selectRecord(item, copy) {
            if (this.form['emr_id']) {
                if (this.form && item['emr_id']) {
                    this.form['emr_id'].$model = item['emr_id']
                }
                if (copy) {
                    let fields = ['name', 'address', 'address2', 'city', 'state', 'zip', 'phone', 'fax', 'website', 'email']
                    for (let field of fields) {
                        if (this.form[field]) {
                            this.form[field].$model = item[field] ? item[field] : ''
                        }
                    }
                }
            }
            this.$root.$emit('bv::hide::modal', this.modal_id)
        },
        async deleteRecord(item) {
            if (await this.$bvModal.msgBoxConfirm(this.$i18n.gt('LABEL_EMR_CONFIRM_DELETE_PRACTICE'))) {
                try {
                    let result = await this.$api.emrDelete(this, 'practice', item['emr_id'], this.$user.practitionerPracticeId(), this.company)
                    if (result) {
                        if (result.issue && Array.isArray(result.issue) && result.issue.length) {
                            let issue = result.issue[0]
                            this.$utils.handleError(null, 'Unable to delete EMR record')
                        } else {
                            this.$refs.dataTable.refresh();
                        }
                    }
                } catch (e) {
                    this.$utils.handleError(e, 'Unable to delete EMR record.')
                }
            }
        }
    },
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.emr-lookup-practice-modal {
    display: inline-block;
}

</style>
